// @ts-ignore
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ChooseRoom from "./components/multistep/ChooseRoom";
import PersonalInformationStep from "../../../components/multistep/PersonalInformationStep";
import PaymentStep from "./components/multistep/PaymentStep";
import BookingConfirmation from "./components/multistep/BookingConfirmation";
import DigitalRoomKey from "./components/multistep/DigitalRoomKey";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { CredentialMapper } from "@sphereon/ssi-types";
import MaenadaAuthenticationQRBooking from "../potential/MaenadaAuthenticationQRBooking";

type BookNowWizardProps = {
  payload: AuthorizationResponsePayload;
  startDate: string;
  endDate: string;
  onApply?: () => void;
};

const BookNowWizard: React.FC<BookNowWizardProps> = (props: BookNowWizardProps) => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [payload, setPayload] = useState<AuthorizationResponsePayload>();
  const [option, setOption] = useState<string>("default");

  const getSubjects = (payload: AuthorizationResponsePayload, index: number = 0) => {
    if (payload) {
      const presentation = CredentialMapper.toWrappedVerifiablePresentation(
        Array.isArray(payload.vp_token)
          ? payload.vp_token[0]
          : payload.vp_token!,
      );
      const subjects =
        presentation?.presentation?.verifiableCredential[index].credential
          .credentialSubject!; // Although rare, a VC can have more than one subject
      return subjects;
    }
    return null;
  }

  useEffect(() => {
    if (window.location.hash.startsWith("#payment")) {
      setActiveStep(4);
      setMounted(true);
      setTermsAccepted(false);
    } else {
      setMounted(true);
      setTermsAccepted(false);
    }

    return () => {
      setActiveStep(0);
      setMounted(false);
    };
  }, []);

  const handleComplete = () => {
    console.log("Form completed!");
    // Handle form completion logic here
    let path = `/hotel`;
    navigate(path);
    window.location.reload();
  };

  const tabChanged = ({
    prevIndex,
    nextIndex,
  }: {
    prevIndex: number;
    nextIndex: number;
  }) => {};

  const updateTermsAccepted = (checked: boolean) => {
    setTermsAccepted(checked);
  };

  const checkValidateTab = () => {
    return termsAccepted;
  };

  const authenticateUser = () => {
    if (props.onApply) {
      props.onApply();
    }
  };

  const getPayload = (payload:AuthorizationResponsePayload) => {
    setPayload(payload);
  };

  const onOptionChosen = (option: string) => {
    setOption(option);
  }


  if (mounted) {
    let fullName = "";
    if (payload)
      fullName = (getSubjects(payload) as any)?.firstName + " " + (getSubjects(payload) as any)?.lastName;
    return (
      <FormWizard
        color={"#aa8453"}
        onComplete={handleComplete}
        onTabChange={tabChanged}
        startIndex={activeStep}
      >
        <FormWizard.TabContent title="Select Options">
          <ChooseRoom onOptionChosen={onOptionChosen} option={option}/>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Pay">
          <PaymentStep startDate={props.startDate} endDate={props.endDate}  payload={props.payload} option={option}
            authenticateUser={() => authenticateUser()}
            signalIfValid={() => true}
            getPayload={getPayload}/>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Booking Confirmation">
          <BookingConfirmation fullName={fullName}/>
          {/* <MaenadaAuthenticationQRBooking></MaenadaAuthenticationQRBooking> */}
        </FormWizard.TabContent>
      </FormWizard>
    );
  }

  return null;
};

export default BookNowWizard;
